module.exports = __webpack_public_path__ + "img/logo_dbc.08c8f677.png";